export default __webpack_public_path__ + "static/char-v-33-0e06fc24db455041092b5eecb103ec98.webp";